import { render } from "./IForm.vue?vue&type=template&id=b8d01070"
import script from "./IForm.vue?vue&type=script&lang=js"
export * from "./IForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__